/**
 * Created by anthony on 6/23/14.
 */

var applicationSidebar = angular.module('applicationSidebar');
applicationSidebar.classy.controller({
    name: 'ParentInfoController',
    inject: ['$scope', '$http', 'ApplicationService', 'SliderFactory', 'authServiceFactory', 'SchoolModelService', 'SliderService', 'ModelService', 'CalculationService', 'FamilyModelService', '$timeout', 'DependantModelFactory'],
    init: function()
    {
        this.$.$modalInstance = this.$modalInstance;
        this.$.authServiceFactory = this.authServiceFactory
        this.$.familyIndex = this.familyIndex;
        this.$.ApplicationService = this.ApplicationService;
        this.$.versionNo = versionNo;
        this.$.SliderService = this.SliderService;
        var parent = this;

        this.familyID = this.ApplicationService.getFamilyData().data[0].familyID;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.anonymous = this.$.schoolinfo.Anonymous; 
        this.$.parents = this.ApplicationService.getFamilyData().data;

        this.initOpened();
        this.$timeout(function() {
            var $window = $(window).on('resize', function() {
                var height = $(this).height() - 206;
                var slideoutTabWidth = $(".slideout-tabs").width();
                $(".slideout-tabs .nav-tabs").css("width", slideoutTabWidth + 'px');
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".data-begins").css("margin-top", slideoutTabHeight + 'px');
            }).trigger('resize');
        }, 300);
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
        this.$.confidential = this.authServiceFactory.getAuth().permissions.confidential;
    },
    watch: {
        'this.SliderService.returnSliders()': function(oldValue, newValue) {
            if (this.$.SliderService.returnSliders().length>0) {
                for (var j = 0; j < this.$.SliderService.returnSliders().length; j++) {
                    if (this.$.SliderService.returnSliders()[j].partial.indexOf("arent") >= 0)
                        var ind = this.$.SliderService.returnSliders()[j].paramObj.tab
                }
                for (var i = 0; i < this.$.parents.length; i++) {
                    this.$.parents[i].active = false;
                }
                if (ind!==undefined) {
                    this.$.parents[ind].active = true;
                }
            }
        }
    },
    initOpened: function()
    {
        this.edited = Array();
        this.opened = Array();
        this.$.Fam_DOB = Array();
        for (var i = 0; i < this.$.parents.length; i++) {
            this.$.Fam_DOB[i] = this.$.parents[i].Fam_DOB.toString().getDateMysqlReversed();
            this.edited[i] = false;
            this.opened[i] = false;
        }
    },
    getField: function(item, field)
    {
        if (item['x' + field] === null || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    newParent: function()
    {
        var parent = this;
        var ind = this.FamilyModelService.new();
        this.ApplicationService.getFamilyData().data[ind].active = 1;
        this.editAge(ind);
        this.initOpened();
        this.$timeout(function() {
            var $window = $(window).on('resize', function(){
                var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
                $(".data-begins").css("margin-top", slideoutTabHeight + 'px');
            }).trigger('resize');
            $('.slideout-content .nav-tabs li:not(.ng-hide):last-of-type').click();
            parent.$.parents[ind].active=true;
        }, 300);
    },
    calcAge: function(dob) {
        var year = dob.toString().substr(0,4);
        var month = dob.toString().substr(4,2);
        var day = dob.toString().substr(6,8);
        var birth = moment(year + '-' + month + '-' + day);
        var now = moment();
        return now.diff(birth, 'years');
    },
    editAge: function(index)
    {
        if (this.$.Fam_DOB[index]!==undefined) {
            var dob = this.$.Fam_DOB[index]
            var year = dob.toString().substr(0,4);
            var month = dob.toString().substr(4,2);
            var day = dob.toString().substr(6,8);
            var birth = moment(year + '-' + month + '-' + day);
            var now = moment();
            this.$.parents[index].age = now.diff(birth, 'years');
        }
    },
    dismiss: function()
    {
        this.$.parents.pop();
    },
    startSaveProcess: function(scope, instance, form, index)
    {
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor = .5;
            this.$.parents[index].Fam_DOB = this.$.Fam_DOB[index]
            this.$.parents[index].Fam_DOB = this.$.parents[index].Fam_DOB.toString().getDateMysqlRegular()
            if (this.$.parents[index].recordID !== null) {
                return this.FamilyModelService.put(this.$.parents[index].recordID, this.$.parents[index], instance)
            }
            else {
                return this.FamilyModelService.post(this.$.parents[index].familyID, this.$.parents[index], instance).then(function(results) {
                    parent.$.parents[index].recordID = results.data.id
                })
            }
        }
        else
            instance.stop(-1);
    },
    startDeleteProcess: function(scope, instance, form, index)
    {
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor = .5;

            this.$.parents[index].deleted = 1;
            return this.FamilyModelService.purge(this.$.parents[index].recordID, this.$.parents[index], instance).then(function(results) {
                parent.ApplicationService.getFamilyData().data.splice(index, 1);
                parent.$.parents.splice(index, 1);
            })
        }
        else
            instance.stop(-1);
    },
    successSave: function (scope, instance, index, callback)
    {
        var parent = this;
        if(instance.options.config.method == "POST")
        {
            this.$.parents[index].recordID = instance.options.data.id;
        }
        if (typeof callback != 'undefined')
            callback();
    },
    successDelete: function (scope, instance, index)
    {
        this.ApplicationService.getFamilyData().data.splice(index, 1);
        this.$.parents.splice(index, 1);
    },
    savePut: function(type, index) {
        var parent = this; 
        angular.forEach(this.$.parents[index], function(value, key) {
                if ((parent.$.parents[index][key]!==undefined) && (parent.$.parents[index][key]=='')) {
                    parent.$.parents[index][key] = parent.$.parents[index]['x'+key];
                }
            }); 
    }
});
